import { useEffect, useState } from "react";
import { KlayiyoInstallGuide } from "../constants";
import AuthModal from "./AuthModal";
import { Klaviyo as KlaviyoIcon } from "../../../../../assets";

const Auth = ({ integrationData, setIntegrationData, setValidAuth }) => {
  const [open, setOpen] = useState(false);
  const [authName, setAuthName] = useState("New authentication");

  useEffect(() => {
    if (integrationData.data) {
      setAuthName(integrationData?.auth_name);
    }
  }, [integrationData]);

  return (
    <div className="text-gray-500 max-h-[500px] overflow-y-scroll">
      {open ? (
        <div className="h-full">
          <AuthModal
            setOpen={setOpen}
            integrationData={integrationData}
            setIntegrationData={setIntegrationData}
            setValidAuth={setValidAuth}
          />
        </div>
      ) : null}

      <div className="md:p-4 p-2">
        <p>
          Connect CausalFunnel with Klaviyo and automatically add new
          subscribers from the pre-chat survey to your mailing list in Klaviyo.
        </p>
        <div className="my-6">
          <h3 className="text-lg font-semibold text-center my-3">
            Connect with Klaviyo account
          </h3>
          <div>
            <p>
              You will need a Private API Key from your Klaviyo account. To get
              it:
            </p>
            <ul className="list-decimal list-inside">
              {KlayiyoInstallGuide?.map((item) => (
                <li key={item.id}>{item.content}</li>
              ))}
            </ul>
            <div className="border-2 p-4 my-3.5" onClick={() => setOpen(true)}>
              <div className="border-2 p-2.5 flex gap-1 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                <KlaviyoIcon
                  className="text-lg text-gray-800"
                  style={{
                    width: "24px",
                    height: "24px",
                  }}
                />
                <p className="text-gray-700">{authName}</p>
              </div>
            </div>
            <p>
              We also described integration step by step in our{" "}
              <a
                href="https://www.causalfunnel.com/blog"
                target="_blank"
                rel="noreferrer noopener"
                className="text-indigo-600 hover:underline "
              >
                Knowledge base.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
